export class  CardDetailViewModel{
    public error: String;
    public msg: String;
    public list_card_details: any;
    constructor(error: String, msg: String, list_card_details: any) {
        this.error = error;
        this.msg = msg;
        this.list_card_details = list_card_details;
    }
}